import HttpHeader from '../Admin/shared/httpheader';
const clientConfig = {
  Keenan: {
    Copyright: `Copyright © ${new Date().getFullYear()} Keenan & Associates • CA Insurance License Number. 0451271`,
    ClientName: 'Keenan',
  },
  Demo: {
    Copyright: 'Copyright 2024 A1M Health Insurance',
    ClientName: 'A1m',
  },
  QA: {
    Copyright: 'Copyright 2024 A1M Health Insurance',
    ClientName: 'A1m',
  },
};

export const Copyright = () => {
  const cName = HttpHeader.getCNAME();
  let copyright = '';
  if (cName.includes('keenan') || cName.includes('tpabenefits')) {
    copyright = clientConfig.Keenan.Copyright;
    return copyright;
  }
  if (cName === 'a1m-qa') {
    copyright = clientConfig.Demo.Copyright;
    return copyright;
  }
  if (cName === 'a1m-demo') {
    copyright = clientConfig.QA.Copyright;
    return copyright;
  }
};

export const getClientName = () => {
  const cName = HttpHeader.getCNAME();
  let copyright = '';
  if (cName.includes('keenan') || cName.includes('tpabenefits')) {
    copyright = clientConfig.Keenan.ClientName;
    return copyright;
  }
  if (cName === 'a1m-qa') {
    copyright = clientConfig.Demo.ClientName;
    return copyright;
  }
  if (cName === 'a1m-demo') {
    copyright = clientConfig.QA.ClientName;
    return copyright;
  }
};
